import { render, staticRenderFns } from "./RebanhoVisitaCard.vue?vue&type=template&id=c71e3db6&"
import script from "./RebanhoVisitaCard.vue?vue&type=script&lang=js&"
export * from "./RebanhoVisitaCard.vue?vue&type=script&lang=js&"
import style0 from "./RebanhoVisitaCard.vue?vue&type=style&index=0&id=c71e3db6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports